import { useEffect } from 'react';

const updateMetaTag = (name, content, attr = 'name') => {
    if (!content) return;
    let element = document.querySelector(`meta[${attr}="${name}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};

const updateLinkTag = (rel, href) => {
    if (!href) return;
    let element = document.querySelector(`link[rel="${rel}"]`);
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
};

const updateJsonLd = (schema) => {
    if (!schema) return;
    const schemaId = 'dynamic-seo-jsonld';
    let script = document.getElementById(schemaId);
    if (!script) {
        script = document.createElement('script');
        script.id = schemaId;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
};

const SEO = ({
    title,
    description,
    keywords,
    canonicalUrl = 'https://thalainagaram.org/',
    ogTitle,
    ogDescription,
    ogImage = 'https://thalainagaram.org/logo.png?v=2',
    ogType = 'website',
    schema
}) => {
    const fullTitle = title 
        ? `${title} | Thalai Nagaram RP` 
        : 'Thalai Nagaram RP | Tamil GTA 5 FiveM Roleplay Server';

    useEffect(() => {
        // Document title
        document.title = fullTitle;

        // Standard Meta
        updateMetaTag('description', description);
        updateMetaTag('keywords', keywords);
        updateLinkTag('canonical', canonicalUrl);

        // Open Graph
        updateMetaTag('og:type', ogType, 'property');
        updateMetaTag('og:site_name', 'Thalai Nagaram RP', 'property');
        updateMetaTag('og:title', ogTitle || fullTitle, 'property');
        updateMetaTag('og:description', ogDescription || description, 'property');
        updateMetaTag('og:url', canonicalUrl, 'property');
        updateMetaTag('og:image', ogImage, 'property');
        if (ogImage.includes('logo.png')) {
            updateMetaTag('og:image:width', '1010', 'property');
            updateMetaTag('og:image:height', '993', 'property');
        }

        // Twitter Card
        updateMetaTag('twitter:card', 'summary_large_image');
        updateMetaTag('twitter:title', ogTitle || fullTitle);
        updateMetaTag('twitter:description', ogDescription || description);
        updateMetaTag('twitter:image', ogImage);

        // JSON-LD Schema
        if (schema) {
            updateJsonLd(schema);
        }

    }, [fullTitle, description, keywords, canonicalUrl, ogTitle, ogDescription, ogImage, ogType, schema]);

    return null;
};

export default SEO;
